import Fito from "@/lib/fito";

import {Plan_100, isInPlanOrTrainerMode} from "@/lib/PlanUtils";

let quizData = null;
async function loadQuiz(login = null) {
    let data;
    if (login && (isInPlanOrTrainerMode(login, Plan_100,'hundred'))) {
        data = await Fito().loadSheet("reports-100")
        console.log("Reports 100")
    }
    else {
        data = await Fito().loadSheet("reports")
        console.log("Reports 90")
    }
    const columns = ["day","weekly","question","options","free_text_on","if_row","if_val"];
    return data.map(row => {
        let x = {};
        for (let i = 0; i < row.length; i++) {
            let v = row[i]
            if (v === null) v = ""
            if (v.indexOf("/") > -1) {
                if (columns[i] === "options") v = v.split("/").map(it => it.trim())
            }
            if (v.length > 0 && !isNaN(v)) v *= 1
            if (v === "Yes" || v === "true") v = true
            if (v === "No" || v === "false") v = false
            x[columns[i].toLowerCase()] = v;
        }
        return x
    })
}

export async function loadTasks(maxDay = 999, login) {
    let sheet;
    if (isInPlanOrTrainerMode(login, Plan_100,'hundred')) {
        sheet = await Fito().loadSheet("tasks-100")
    }
    else {
        sheet = await Fito().loadSheet("learned-tasks")
    }

    let data = sheet;
    console.log({data})

    const columns = ["task","day","content","details"];
    return data.map(row => {
        let x = {};
        for (let i = 0; i < row.length; i++) {
            let v = row[i]
            if (columns[i].toLowerCase() === "day") v *= 1
            x[columns[i].toLowerCase()] = v;
        }
        return x
    }).filter(it => it.day*1 <= maxDay).sort((a,b) => a.day > b.day ? -1 : 1)
}

export async function getDailyQuiz(day, login) {
    if (!quizData) quizData = await loadQuiz(login)
    return quizData.filter(it => it.day*1 === day)
}

export async function getQuizDays(login) {
    if (!quizData) quizData = await loadQuiz(login)
    let days = {}
    for (let d of quizData) days[d.day*1] = true
    return Object.keys(days).map(it => it*1)
}
